export default "__VITE_ASSET__d3fE$6w3__"